// import * as analytics from '@anm/analytic';
import api from '@anm/api';
// import getCancelSource from '@anm/api/helpers/getCancelSource';
import {
  // CreateNewVideoData,
  GetFileUploadUrlRequest,
  // ReplaceVideoParams,
  UpdateVideoConfigsProps,
  UpdateVideoMetaData,
  UpdateVideoPasswordProps,
  UploadFileProps
  // UploadVideoProps
} from '@anm/api/modules/hosting/types';
import { EmbedInfo } from '@anm/api/modules/projects/types';
// import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';
// import getVideoInfo, { getVideoPropsFromFile } from '@anm/helpers/getVideoInfo';
import logger from '@anm/helpers/logger';
import asyncEntity from '@anm/helpers/redux/asyncEntity';
// import createFileProgressChannel from '@anm/helpers/redux/createProgressChannel';
import { call, fork, put, select, take, takeLatest } from '@anm/helpers/saga/effects';
import { takeType } from '@anm/helpers/saga/typesafe-actions';
import { appNotificationActions } from '@anm/store/modules/appNotifications';
// import checkCanUpload from '@anm/store/modules/uploads/uploadRestrictions';

import { appMetaSelectors } from '../appMeta';
import { landingsActions } from '../landings';
import { projectSelectors } from '../project';
import { userSelectors } from '../user';
// import { selectCanPurchaseStorage } from '../user/selectors';
// import { selectCreatedProject } from '../videoFolder/selectors';

import { hostedVideoActions, hostedVideoSelectors } from '.';
import { saveVideoConfigs, toggleNotifications, updateConfigs } from './actions';
import { isPosterSizeBig } from './helpers';
import { selectVideoConfigs } from './selectors';
import { UploadFileParams } from './types';
// import { uploadsActions } from '@anm/store/modules/uploads';

// let uploadCancelSource: CancelTokenSource;

const getHostedVideoFoldersRequest = () => api().hosting.getHostedVideoFolders({ folder: '/' });
const getUserVideosAsync = asyncEntity(hostedVideoActions.getHostedVideoFoldersAsync, getHostedVideoFoldersRequest);

function* watchGetUserVideos() {
  while (true) {
    yield take(takeType(hostedVideoActions.getHostedVideoFolders));
    yield call(getUserVideosAsync);
  }
}

// const createVideoRequest = (data: CreateNewVideoData) => api().hosting.createNewVideo(data);
// const createVideoRequest = (data: CreateUploadRequest) => api().uploads.createUpload(data);
// const createUploadRequest = (data: CreateNewVideoData) => api().hosting.createNewUpload(data);

// const createVideoAsync = asyncEntity(hostedVideoActions.createVideoAsync, createVideoRequest);
// const createUploadAsync = asyncEntity(uploadsActions.uploadFileAsync, createUploadRequest);

// const uploadFile = (data: UploadFileProps) => {
//   uploadCancelSource = getCancelSource();

//   return api().hosting.uploadNewVideo({
//     ...data,
//     token: uploadCancelSource.token
//   });
// };

// function* trackFailedUploadEvent(error: string) {
//   try {
//     const { project } = yield select(selectCreatedProject);
//     const file = yield* select(selectCreatedFile);

//     if (!file) {
//       logger('Can not find any uploaded video file');
//       return;
//     }

//     const extension = getExtensionFromPath(file.name) || '';

//     const { width, height, duration } = project;

//     analytics.trackCreateProjectFromUpload({
//       error,
//       width,
//       height,
//       duration,
//       extension,
//       size: file.size,
//       uploadStatus: 'failed',
//       projectStatus: 'failed'
//     });
//   } catch {
//     console.error(`Can't collect props for failed upload event`);
//   }
// }

// function* uploadVideoAsync(data: UploadVideoProps) {
//   const uploadFileChannel = createFileProgressChannel<UploadFileProps, string>(uploadFile);

//   yield put(hostedVideoActions.uploadVideoAsync.request({} as UploadVideoData));

//   const channel = yield* call(uploadFileChannel, data);

//   while (true) {
//     const { progress = 0, err, success } = yield take(channel);

//     if (success) {
//       yield put(hostedVideoActions.uploadVideoAsync.success(success));
//       return;
//     }
//     if (err) {
//       yield call(trackFailedUploadEvent, err);
//       yield put(hostedVideoActions.uploadVideoAsync.failure(err));
//       return;
//     }

//     const { hostId } = data;

//     yield put(hostedVideoActions.uploadVideoProgress({ progress, id: hostId }));
//   }
// }

// function* createVideo({ createVideoData, file, canIgnoreStorage, uploadType = 'new' }: CreateVideoParams) {
//   const { id, extension, meta, isUpload, folderId } = createVideoData || {};
//   const fileInfo = yield* call(getInfoFromVideo, file);
//   const canPurchaseStorage = yield* select(selectCanPurchaseStorage);
//   const limits = yield* select(userSelectors.selectUploadVideoLimits);
//   const isMaxPlan = yield* select(userSelectors.selectIsMaxWavePlan);
//   const canUpgrade = !isMaxPlan;

//   switch (uploadType) {
//     case 'new': {
//       const canUpload = yield* call(checkCanUpload, {
//         file,
//         limits,
//         isUpload,
//         canUpgrade,
//         extension,
//         canIgnoreStorage,
//         canPurchaseStorage
//       });

//       if (canUpload) {
//         yield* call(
//           createVideoAsync,
//           {
//             id,
//             meta,
//             fileInfo,
//             extension: extension!
//           },
//           { id, file, isUpload, folderId, uploadType }
//         );
//       }
//       return;
//     }
//     case 'replace': {
//       yield* call(
//         createUploadAsync,
//         {
//           id,
//           meta,
//           fileInfo,
//           extension: extension!
//         },
//         { id, file, isUpload, folderId, uploadType }
//       );
//     }
//   }
// }

// function* getInfoFromVideo(file?: File) {
//   if (!file) return;

//   try {
//     const { duration, width, height } = yield* call(getVideoInfo, getVideoPropsFromFile(file));

//     const fileInfo = {
//       width,
//       height,
//       duration
//     };

//     return fileInfo;
//   } catch (e) {
//     return undefined;
//   }
// }

// function* watchCreateVideo() {
//   while (true) {
//     const { payload }: ReturnType<typeof hostedVideoActions.createVideo> = yield take(
//       takeType(hostedVideoActions.createVideo)
//     );

//     yield call(createVideo, payload);
//   }
// }

// function* uploadVideo() {
//   const { url, hostId, uploadType }: CreateVideoData = yield* select(selectCreatedVideoData);
//   const file = yield* select(selectCreatedFile);

//   if (!file) {
//     logger('Can not find any uploaded video file');
//     return;
//   }

//   yield call(uploadVideoAsync, { url, file, hostId, uploadType });
// }

// function* watchCreateVideoSuccess() {
//   while (true) {
//     yield take(takeType(hostedVideoActions.createVideoAsync.success));

//     const isUpload = yield* select(hostedVideoSelectors.selectIsUploadCreatedVideo);

//     if (isUpload) {
//       yield fork(uploadVideo);
//     }
//   }
// }

function* enableNotifications() {
  const canNotify = yield* select(hostedVideoSelectors.selectNotificationsStatus);

  if (!canNotify) {
    yield put(hostedVideoActions.toggleNotifications(true));
  }
}

function* watchSaveConfigsOrLanding() {
  while (true) {
    yield takeLatest(
      [
        takeType(landingsActions.saveLandingAsync.success),
        takeType(landingsActions.saveLandingAsync.failure),
        takeType(hostedVideoActions.saveVideoConfigsAsync.success),
        takeType(hostedVideoActions.saveVideoConfigsAsync.failure)
      ],
      enableNotifications
    );
  }
}

const deleteVideoRequest = (id: string) => api().uploads.deleteUploadFile(id);
const deleteVideoAsync = asyncEntity(hostedVideoActions.deleteVideoAsync, deleteVideoRequest);

function* watchDeleteVideo() {
  while (true) {
    const { payload: id } = yield take(takeType(hostedVideoActions.deleteVideo));
    yield call(deleteVideoAsync, id, id);
  }
}

const getManifestRequest = (id: string) => api().hosting.getManifest(id);
const getManifestAsync = asyncEntity(hostedVideoActions.getManifestAsync, getManifestRequest);

function* watchGetManifest() {
  while (true) {
    const { payload: id } = yield take(takeType(hostedVideoActions.getManifest));

    yield call(getManifestAsync, id, id);
  }
}

const uploadCustomPosterRequest = (data: UploadFileProps) => api().hosting.uploadFile(data);

const uploadCustomPosterAsync = asyncEntity(hostedVideoActions.uploadCustomPosterAsync, uploadCustomPosterRequest);

const getPosterUploadUrlRequest = (data: GetFileUploadUrlRequest) => api().hosting.getPosterUploadUrl(data);

function* sendPosterSizeError() {
  yield put(
    hostedVideoActions.uploadCustomPosterAsync.failure({
      code: 409,
      message: 'Uploaded poster is too big, limit is 10 MB'
    })
  );
}

function* fetchUrlAndUploadPoster({ file, extension, hostId }: UploadFileParams) {
  const {
    request: { url }
  } = yield* call(getPosterUploadUrlRequest, { hostId, extension });

  yield fork(uploadCustomPosterAsync, { url, file }, { file, extension, hostId });
}

function* uploadCustomPoster(data: UploadFileParams) {
  if (isPosterSizeBig(data.file)) {
    return yield* call(sendPosterSizeError);
  }

  try {
    yield* call(fetchUrlAndUploadPoster, data);
  } catch (e) {
    yield* put(
      hostedVideoActions.uploadCustomPosterAsync.failure({
        code: 405,
        message: "The poster hasn't been uploaded"
      })
    );
  }
}

function* watchUploadCustomPoster() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.uploadCustomPoster> = yield take(
      takeType(hostedVideoActions.uploadCustomPoster)
    );

    yield fork(uploadCustomPoster, action.payload);
  }
}

const saveEmbedStatusRequest = (data: EmbedInfo) => api().projects.setEmbedStatus(data);
const saveEmbedStatusAsync = asyncEntity(hostedVideoActions.saveEmbedStatusAsync, saveEmbedStatusRequest);

function* watchToggleEmbedStatus() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.toggleEmbedStatus> = yield take(
      takeType(hostedVideoActions.toggleEmbedStatus)
    );

    const projectId = yield* select(projectSelectors.selectCurrentProjectId);
    const workspace = yield* select(appMetaSelectors.selectWorkspace);

    if (!projectId) {
      logger(`projectId not provided: ${projectId}`);
      return;
    }

    const saveParams = { workspace, embed: action.payload, projectIds: projectId };

    yield call(saveEmbedStatusAsync, saveParams);
  }
}

const updateVideoPasswordRequest = (data: UpdateVideoPasswordProps) => api().hosting.updateVideoData(data);

const saveVideoPasswordAsync = asyncEntity(hostedVideoActions.saveVideoPasswordAsync, updateVideoPasswordRequest);

function* watchSaveVideoPassword() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.saveVideoPassword> = yield take(
      takeType(hostedVideoActions.saveVideoPassword)
    );

    yield call(saveVideoPasswordAsync, action.payload, action.payload.security);
  }
}

const updateVideoConfigsRequest = (data: UpdateVideoConfigsProps) => api().hosting.updateVideoData(data);

const saveVideoConfigsAsync = asyncEntity(hostedVideoActions.saveVideoConfigsAsync, updateVideoConfigsRequest);

function* watchSaveVideoConfigs() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.saveVideoConfigs> = yield take(
      takeType(hostedVideoActions.saveVideoConfigs)
    );

    const { configs } = action.payload;

    yield call(saveVideoConfigsAsync, action.payload, configs);
  }
}

// function* watchUploadCancel() {
//   while (true) {
//     yield take(takeType(hostedVideoActions.cancelUpload));

//     uploadCancelSource.cancel();
//   }
// }

const updateVideoMetaRequest = (data: UpdateVideoMetaData) => api().hosting.updateVideoData(data);

const updateVideoMetaAsync = asyncEntity(hostedVideoActions.getManifestAsync, updateVideoMetaRequest);

function* watchUpdateVideoMeta() {
  while (true) {
    const { payload } = yield take(takeType(hostedVideoActions.saveVideoMeta));

    yield fork(updateVideoMetaAsync, payload);
  }
}

function* watchTogglePlayerLogo() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.setVideoData> = yield take(
      takeType(hostedVideoActions.setVideoData)
    );

    yield fork(togglePlayerLogo, action.payload.hostId);
  }
}

function* togglePlayerLogo(videoId: string) {
  const configs = yield* select(selectVideoConfigs);
  if (!configs) return;

  const isUserFree = yield* select(userSelectors.selectIsUserFree);
  const isLogoDisabled = !configs.playbar?.logo;

  const shouldTurnOnLogo = isUserFree && isLogoDisabled;
  const shouldTurnOffLogo = !isUserFree && !isLogoDisabled;
  const shouldUpdateLogo = shouldTurnOnLogo || shouldTurnOffLogo;

  if (!shouldUpdateLogo) return;

  const newConfigs = {
    ...configs,
    playbar: { ...configs.playbar, logo: shouldTurnOnLogo ? true : false }
  };

  yield put(toggleNotifications(false));
  yield put(updateConfigs(newConfigs));
  yield put(saveVideoConfigs({ configs: newConfigs, hostId: videoId }));
}

const checkUploadAsync = asyncEntity(hostedVideoActions.checkUploadAsync, (id: string) =>
  api().uploads.getUploadMedia({ id, isCached: false })
);

function* watchCheckUpload() {
  while (true) {
    const action: ReturnType<typeof hostedVideoActions.checkUpload> = yield take(
      takeType(hostedVideoActions.checkUpload)
    );

    yield call(checkUploadAsync, action.payload);
  }
}

// function* watchUploadVideoSuccess() {
//   while (true) {
//     yield* take(takeType(hostedVideoActions.uploadVideoAsync.success));

//     yield call(replaceVideo);
//   }
// }

// function* replaceVideo() {
//   const { hostId: hostingId, uploadId, uploadType }: CreateVideoData = yield* select(selectCreatedVideoData);
//   const manifestId = yield* select(selectHostId);

//   const hostId = hostingId || manifestId;

//   if (uploadType === 'replace' && hostId) {
//     yield* call(replaceVideoAsync, { hostId, uploadId });
//   }
// }

// const replaceVideoAsync = asyncEntity(hostedVideoActions.replaceVideoAsync, (params: ReplaceVideoParams) =>
//   api().hosting.replaceVideo(params)
// );

function* watchReplaceVideoSuccess() {
  while (true) {
    yield* take(takeType(hostedVideoActions.replaceVideoAsync.success));

    yield* put(
      appNotificationActions.notify({
        type: 'success',
        description: 'The video has been uploaded and will be replaced in the next couple of minutes.'
      })
    );
  }
}

function* watchReplaceVideoFailure() {
  while (true) {
    yield* take(takeType(hostedVideoActions.replaceVideoAsync.failure));

    yield* put(
      appNotificationActions.notify({
        type: 'error',
        description: `Replace video error, please try again later.`
      })
    );
  }
}

const hostedVideoWatchers = () => [
  call(watchTogglePlayerLogo),
  call(watchCheckUpload),
  // call(watchCreateVideo),
  call(watchDeleteVideo),
  call(watchGetManifest),
  // call(watchUploadCancel),
  call(watchGetUserVideos),
  call(watchUpdateVideoMeta),
  call(watchSaveVideoConfigs),
  call(watchToggleEmbedStatus),
  call(watchSaveVideoPassword),
  // call(watchCreateVideoSuccess),
  call(watchSaveConfigsOrLanding),
  call(watchUploadCustomPoster),
  // call(watchUploadVideoSuccess),
  call(watchReplaceVideoFailure),
  call(watchReplaceVideoSuccess)
];

export default hostedVideoWatchers;
